import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
export const usePageState = () => {
  const $ = _c(83);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname?.includes("ach-refunds");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pathname) {
    t1 = pathname?.includes("contacts/confirmation") ?? false;
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== pathname) {
    t2 = pathname?.includes("dashboard") ?? false;
    $[4] = pathname;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = pathname === "/" || pathname === "/dashboard";
  let t4;
  if ($[6] !== pathname) {
    t4 = (pathname?.includes("consumers") ?? false) && (pathname?.includes("edit") ?? false);
    $[6] = pathname;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== pathname) {
    t5 = pathname?.includes("home-quotes/") ?? false;
    $[8] = pathname;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== pathname) {
    t6 = pathname?.includes("quotes/new") ?? false;
    $[10] = pathname;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== pathname) {
    t7 = pathname?.includes("contacts/search") ?? false;
    $[12] = pathname;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== pathname) {
    t8 = pathname?.includes("users") ?? false;
    $[14] = pathname;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== pathname) {
    t9 = pathname?.includes("roles") ?? false;
    $[16] = pathname;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== pathname) {
    t10 = pathname?.includes("deal-log") ?? false;
    $[18] = pathname;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== pathname) {
    t11 = pathname?.includes("cancel-pendings") ?? false;
    $[20] = pathname;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== pathname) {
    t12 = pathname?.includes("cancel-rewrites") ?? false;
    $[22] = pathname;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== pathname) {
    t13 = pathname?.includes("post-date-declines") ?? false;
    $[24] = pathname;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== pathname) {
    t14 = pathname?.includes("contacts/waiting") ?? false;
    $[26] = pathname;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== pathname) {
    t15 = pathname?.includes("wrap-up") ?? false;
    $[28] = pathname;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== pathname) {
    t16 = pathname?.includes("scratchpad") ?? false;
    $[30] = pathname;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== pathname) {
    t17 = pathname?.includes("retention-discounts") ?? false;
    $[32] = pathname;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== pathname) {
    t18 = pathname?.includes("transfer-ownerships-eds") ?? false;
    $[34] = pathname;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== pathname) {
    t19 = pathname?.includes("transfer-ownerships-non-eds") ?? false;
    $[36] = pathname;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== pathname) {
    t20 = pathname?.includes("physical-checks") ?? false;
    $[38] = pathname;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== pathname) {
    t21 = pathname?.includes("vin-audit") ?? false;
    $[40] = pathname;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== pathname) {
    t22 = pathname?.includes("missing-down-payment") ?? false;
    $[42] = pathname;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== pathname) {
    t23 = pathname?.includes("pro-rated-refund") ?? false;
    $[44] = pathname;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== pathname) {
    t24 = pathname?.includes("contract-transmittal-events-errors") ?? false;
    $[46] = pathname;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== pathname) {
    t25 = pathname?.includes("duplicate-saves") ?? false;
    $[48] = pathname;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== pathname) {
    t26 = pathname?.includes("funded-full-refunds") ?? false;
    $[50] = pathname;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== pathname) {
    t27 = pathname?.includes("in-progress-fulfillments") ?? false;
    $[52] = pathname;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t0 || $[55] !== t1 || $[56] !== t10 || $[57] !== t11 || $[58] !== t12 || $[59] !== t13 || $[60] !== t14 || $[61] !== t15 || $[62] !== t16 || $[63] !== t17 || $[64] !== t18 || $[65] !== t19 || $[66] !== t2 || $[67] !== t20 || $[68] !== t21 || $[69] !== t22 || $[70] !== t23 || $[71] !== t24 || $[72] !== t25 || $[73] !== t26 || $[74] !== t27 || $[75] !== t3 || $[76] !== t4 || $[77] !== t5 || $[78] !== t6 || $[79] !== t7 || $[80] !== t8 || $[81] !== t9) {
    t28 = {
      isAchRefundsPage: t0,
      isContactConfirmationPage: t1,
      isDashboardPage: t2,
      isHomePage: t3,
      isEditConsumerPage: t4,
      isHomeQuotePage: t5,
      isNewQuotePage: t6,
      isSearchPage: t7,
      isUsersPage: t8,
      isRolesPage: t9,
      isDealsLogPage: t10,
      isCancelPendingsPage: t11,
      isCancelRewritesPage: t12,
      isPostDateDeclinesPage: t13,
      isWaitForCallPage: t14,
      isWrapUpPage: t15,
      isScratchpad: t16,
      isRetentionDiscountsPage: t17,
      isTransferOwnershipsPage: t18,
      isNonEdsTransferOwnershipsPage: t19,
      isPhysicalChecksPage: t20,
      isVinAuditPage: t21,
      isMissingDPPage: t22,
      isProRatedRefundPage: t23,
      isContractTransmittalEventsErrorsPage: t24,
      isDuplicateSavesPage: t25,
      isFundedFullRefundsPage: t26,
      isInProgressFulfillmentsPage: t27
    };
    $[54] = t0;
    $[55] = t1;
    $[56] = t10;
    $[57] = t11;
    $[58] = t12;
    $[59] = t13;
    $[60] = t14;
    $[61] = t15;
    $[62] = t16;
    $[63] = t17;
    $[64] = t18;
    $[65] = t19;
    $[66] = t2;
    $[67] = t20;
    $[68] = t21;
    $[69] = t22;
    $[70] = t23;
    $[71] = t24;
    $[72] = t25;
    $[73] = t26;
    $[74] = t27;
    $[75] = t3;
    $[76] = t4;
    $[77] = t5;
    $[78] = t6;
    $[79] = t7;
    $[80] = t8;
    $[81] = t9;
    $[82] = t28;
  } else {
    t28 = $[82];
  }
  return t28;
};
export type TPageState = {
  isAchRefundsPage: boolean;
  isContactConfirmationPage: boolean;
  isDashboardPage: boolean;
  isHomePage: boolean;
  isEditConsumerPage: boolean;
  isHomeQuotePage: boolean;
  isNewQuotePage: boolean;
  isSearchPage: boolean;
  isUsersPage: boolean;
  isRolesPage: boolean;
  isDealsLogPage: boolean;
  isCancelPendingsPage: boolean;
  isCancelRewritesPage: boolean;
  isPostDateDeclinesPage: boolean;
  isWaitForCallPage: boolean;
  isWrapUpPage: boolean;
  isScratchpad: boolean;
  isRetentionDiscountsPage: boolean;
  isNonEdsTransferOwnershipsPage: boolean;
  isTransferOwnershipsPage: boolean;
  isPhysicalChecksPage: boolean;
  isVinAuditPage: boolean;
  isMissingDPPage: boolean;
  isProRatedRefundPage: boolean;
  isContractTransmittalEventsErrorsPage: boolean;
  isDuplicateSavesPage: boolean;
  isFundedFullRefundsPage: boolean;
  isInProgressFulfillmentsPage: boolean;
};